import { useTheme } from '@emotion/react';
import { Lock, Protect } from '@icon-park/react';
import { memo } from 'react';

import { QUEST_STATUSES } from '@didaskill/domain/user-achievements/constants';
import { Typography } from '@didaskill/ui/design-system';
import { ComponentSwitch } from '@didaskill/ui/utils';

import type { QuestProgress } from './QuestTile';

type QuestTileIconProps = {
  status: QUEST_STATUSES;
  progress?: QuestProgress;
};

const QuestTileIconBase = ({ status, progress }: QuestTileIconProps) => {
  const theme = useTheme();
  return (
    <ComponentSwitch value={status}>
      <ComponentSwitch.Item value={QUEST_STATUSES.IN_PROGRESS}>
        <Typography variant={Typography.VARIANTS.BODY_MEDIUM_BOLD}>
          {progress?.completed}/{progress?.total}
        </Typography>
      </ComponentSwitch.Item>

      <ComponentSwitch.Item value={QUEST_STATUSES.LOCKED}>
        <Lock size={22} fill={[theme.colors.gray[500], theme.colors.warning[500]]} />
      </ComponentSwitch.Item>

      <ComponentSwitch.Item value={QUEST_STATUSES.COMPLETED}>
        <Protect size={22} fill={[theme.colors.success[500], theme.colors.success[100]]} />
      </ComponentSwitch.Item>
    </ComponentSwitch>
  );
};

QuestTileIconBase.displayName = 'QuestTileIcon';

export const QuestTileIcon = memo(QuestTileIconBase);
